import { useSelector } from 'react-redux'

import { selectIsAsyncOptimizerEnabled } from 'data/tenant/tenantSettingsSelectors'

import { notificationLiveSet, type NotificationLiveSet } from './notificationCenterViews'

/**
 * The producers this tenant can actually receive. Route optimization is gated per tenant, so without it
 * there is no Routing view, no area option and no toggle — what a producer gets before its write path exists.
 */
export const useNotificationLiveSet = (): NotificationLiveSet => {
  const isOptimizerEnabled = useSelector(selectIsAsyncOptimizerEnabled)
  return notificationLiveSet(isOptimizerEnabled)
}

export default useNotificationLiveSet
